// import React, {Component} from 'react';
import PbAjax from '../../lib/pbajax';
import publicpb from '../../base/public.pb';
import profilepb from './index.pb';
import visitor from '../visitor/index';
import Cache from 'c-cache';
import Url from 'c-url';

let mock = 0;

if (Url.query('lock')) {
    mock = 1;
}

let pbajax = new PbAjax();

let cache = new Cache({
    prefix: 'pcuplive'
});

class Profile {
    constructor(vuid) {
        if (typeof vuid =='object') {
            vuid = longToString(vuid);
        }
        this.promise = this.getData({
            vuid: parseInt(vuid, 10)
        });
        this.vuid = vuid;
    }

    getData(data) {

        let self = this;
        let businessData = new profilepb.Profile.Get.Request(data);
        let defer = $.Deferred();
        let userToken = UP.Global.getUserToken();

        pbajax.do({
                service: 'service',
                api: '/profile/get',
                header: {
                    userToken,
                    lang: UP.Global.siteLanguage
                }
            },
            businessData,
            function(res) {

                let dataWrap = publicpb.Result.decode(res);
                let data;

                if (dataWrap.code == 1) {
                    data = profilepb.Profile.Get.Response.decode(dataWrap.data.value);

                    if (self.vuid == UP.Global.getUserId()) {
                        data.userToken = userToken;
                    }
                    let userInfo = Object.assign({}, data.profile, self.parseData(data.profile), {
                        userLabels: data.userLabels,
                        canPermissions: data.canPermissions
                    });
                    
                    // console.info('loginUserSuccess', userInfo);

                    defer.resolve(userInfo);

                } else {
                    if (dataWrap.code == 8192) {
                        // console.log('profile = 8192登录');
                        // $.channel.emit('login');
                        self.checkVisitorMode();
                    } else {
                        defer.reject();
                    }
                }                
            },
            () => {
                if (mock == 1) { alert('接口请求失败'); }
                
                defer.reject();
            },
            () => {
                if (mock == 1) { alert('请求超时'); }
                defer.reject();
            }
        );

        return defer.promise();
    }

    /*
     * 解析数据
     */
    parseData(data) {
        let balance = data.balance || {};
        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            grade: data.grade > 0 ? data.grade : 1,
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
        }
    }

    longToString(value) {
        return window.longToString(value);
    }

    longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }

    checkVisitorMode() {
        this.visitor();
    }

    visitor() {
        cache.setCache('isRegisterRealUser', false);
        
        if (typeof SMSdk !== 'undefined') {
            visitor.register();
        } else {
            $.channel.on('smsdkLoaded', () => {
                visitor.register();
            });
            $.channel.on('smsdkLoadedError', () => {
                visitor.register();
            });
        }
    }
}

export default Profile;



// WEBPACK FOOTER //
// ./js/component/profile/index.js